import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './ButtonTraining.css';
import { RiCheckboxLine, RiCheckboxBlankLine } from 'react-icons/ri'; // Import checkbox icons

const ButtonTraining = ({ value, className, onClick, disabled, completed, tooltipMessage }) => {
    // Initialize Bootstrap tooltips
    useEffect(() => {
        if (tooltipMessage && tooltipMessage.trim() !== '') {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            [...tooltipTriggerList].map((tooltipTriggerEl) =>
                new window.bootstrap.Tooltip(tooltipTriggerEl)
            );
        }
    }, [tooltipMessage]);

    return (
        <button
            className={`btn btn-training ml-lg-2 mr-lg-0 mr-2 ${className}`}
            onClick={onClick}
            disabled={disabled}
            data-bs-toggle={tooltipMessage && tooltipMessage.trim() !== '' ? 'tooltip' : null}
            data-bs-placement="top" // TODO: Not working, tooltip is appear on the bottom
            title={tooltipMessage}
        >
            {/* Icon on the left */}
            <span>
                {completed ? (
                    <RiCheckboxLine className="icon-lift-3 icon-left" />
                ) : (
                    <RiCheckboxBlankLine className="icon-lift-3 icon-left" />
                )}
            </span>
            {value}
        </button>
    );
};

export default ButtonTraining;

